/*
 *  Copyright (C) 2025 - SimpliCity Digital Inc - All Rights Reserved
 */

import React, { Fragment } from "react";
import { ImageEditDialogTopActions } from "cms/images/image-selector/dialog-edit/actions/image-dialog-top-actions";
import { ImageEditPropertiesPanel } from "cms/images/image-selector/dialog-edit/panels/image-edit-panel-properties";
import { ImageEditPlacementsPanel } from "cms/images/image-selector/dialog-edit/panels/image-edit-panel-placements";
// import { ImageEditCategoriesPanel } from "./image-edit-panel-categories";

const ImageEditPanel = () => {

    return (
        <Fragment>
            <ImageEditDialogTopActions />
            <div className='edit-panel edit-image'>

                <ImageEditPropertiesPanel />

                <ImageEditPlacementsPanel />

                {/*<ImageEditCategoriesPanel />*/}

            </div>
        </Fragment>
    );
};

export { ImageEditPanel };
